export default __webpack_public_path__ + "static/media/spa_resume.2572cfed.pdf";